export const getStringParams = (params: any = {}) => Object.entries(params).reduce(
  (str, entry, idx) => {

    if (idx !== 0) {
      str += '&'
    }
    if (idx === 0) {
      str += '?'
    }

    str += `${entry[0]}=${entry[1]}`
    return str
  },
  ''
)